/**
 * EsconderMotoristaCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {EsconderMotorista} from '@/model/resource/EsconderMotorista'

/* TODO: review generated class */
@HttpExclude()
export class EsconderMotoristaCollection extends PageCollection<
  EsconderMotorista
> {
  constructor() {
    super(EsconderMotorista)
  }

  queryAsPage() {
    return this.listEsconderMotorista()
  }

  async listEsconderMotorista() {
    return await Request.get(`/admin/esconder-motorista`, {params: this.params})
      .name('listEsconderMotorista')
      .as(this)
      .getResponse()
  }

  async listCsvEsconderMotorista() {
    return await Request.get(`/admin/esconder-motorista/csv`, {
      params: this.params,
    })
      .name('listCsvEsconderMotorista')
      .as(this)
      .getResponse()
  }
}
